import React from 'react';
import autoBind from 'react-autobind';
import Localization from "../Localization.jsx";
import {
  Modal,
  Box,
  Flex,
  Group,
  Text,
  NavLink,
  ScrollArea,
  Select,
  Divider,
  CloseButton,
} from '@mantine/core';
import { IconLanguage } from '@tabler/icons-react';
import { BRAND_PRIMARY } from "../theme/brandTheme.js";

const SETTINGS_SECTIONS = {
  LANGUAGE: 'language',
};

class SettingsDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSection: SETTINGS_SECTIONS.LANGUAGE,
    };
    autoBind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      this.setState({ selectedSection: SETTINGS_SECTIONS.LANGUAGE });
    }
  }

  handleSectionChange(section) {
    this.setState({ selectedSection: section });
  }

  changeLanguage(language) {
    Localization.setLanguage(language);
    this.props.root.languageChanged();
    this.forceUpdate();
  }

  renderLanguageSection() {
    const currentLanguage = Localization.strings.getLanguage();

    return (
      <Box>
        <Text fw={600} size="lg" mb="md">
          {Localization.strings.LANGUAGE}
        </Text>

        <Divider />

        <Group justify="space-between" align="center" py="md">
          <Text>{Localization.strings.LANGUAGE}</Text>
          <Select
            w={200}
            allowDeselect={false}
            value={currentLanguage}
            onChange={(value) => this.changeLanguage(value)}
            data={[
              { value: 'en', label: Localization.strings.LANGUAGE_ENGLISH_LABEL },
              { value: 'tc', label: Localization.strings.LANGUAGE_TRADITIONAL_CHINESE_LABEL },
            ]}
          />
        </Group>

        <Divider />
      </Box>
    );
  }

  renderContent() {
    switch (this.state.selectedSection) {
    case SETTINGS_SECTIONS.LANGUAGE:
    default:
      return this.renderLanguageSection();
    }
  }

  render() {
    return (
      <Modal
        opened={this.props.open}
        onClose={this.props.onClose}
        withCloseButton={false}
        padding={0}
        size="lg"
        radius="md"
        centered
        zIndex={2000}
        styles={{
          content: { height: 480, maxHeight: '80vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
          body: { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', padding: 0 },
        }}
      >
        {/* Brand header */}
        <Group justify="space-between" px="lg" style={{ height: 56, flexShrink: 0, backgroundColor: BRAND_PRIMARY }}>
          <Text c="white" fw={600} fz="lg">{Localization.strings.APP_SETTINGS}</Text>
          <CloseButton onClick={this.props.onClose} variant="transparent" c="white" size="lg" />
        </Group>

        {/* Body: sidebar + content */}
        <Flex style={{ flex: 1, minHeight: 0 }}>
          <Box
            style={{
              width: 180,
              flexShrink: 0,
              borderRight: '1px solid #e9ecef',
              backgroundColor: '#f8f9fa',
              overflowY: 'auto',
              paddingTop: 8,
              paddingBottom: 8,
            }}
          >
            <NavLink
              active={this.state.selectedSection === SETTINGS_SECTIONS.LANGUAGE}
              label={Localization.strings.LANGUAGE}
              leftSection={<IconLanguage size={18} />}
              onClick={() => this.handleSectionChange(SETTINGS_SECTIONS.LANGUAGE)}
            />
          </Box>
          <ScrollArea style={{ flex: 1 }}>
            <Box p="xl">
              {this.renderContent()}
            </Box>
          </ScrollArea>
        </Flex>
      </Modal>
    );
  }
}

export default SettingsDialog;
